import * as types from "./actionTypes";

export const addOrUpdateResourcePassword = (resourceKey, data) => async (dispatch, getState) => {
    dispatch({ type: types.RESOURCE_PASSWORD_UPDATED, payload: {resourceKey, data} });
}

export const deleteResourcePassword = (resourceKey) => async (dispatch, getState) => {
    dispatch({ type: types.RESOURCE_PASSWORD_DELETED, payload: {resourceKey} });
}